var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { DatePipe } from '@angular/common';
import { UploadService } from './../d-i/upload.service';
import { NgSelectComponent } from '@ng-select/ng-select';
var DocumentRepositoryComponent = /** @class */ (function () {
    function DocumentRepositoryComponent(userService, spinner, bpgCommonService, bpgEventsService, router, environment, datePipe, uploadService) {
        this.userService = userService;
        this.spinner = spinner;
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.router = router;
        this.environment = environment;
        this.datePipe = datePipe;
        this.uploadService = uploadService;
        this.LandingPaginationDTO = new LandingPaginationDTO();
        this.user = null;
        this.role = null;
        this.roleName = null;
        this.userFirstName = null;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.createdBy = this.loginData.userId;
        this.modifiedBy = this.loginData.userId;
        this.userId = this.loginData.userId;
        this.adminId = localStorage.getItem('adminId');
        this.currentPage = 0;
        this.currentNumberOfElements = 10;
        this.totalPages = 0;
        this.limit = 10;
        this.currentShowingElements = 10;
        this.selectedSiteId = Number(localStorage.getItem('userSiteId'));
        this.loginUserAdminId = localStorage.getItem('adminId');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
        this.eventPicture = true;
        this.uploadFileName = null;
        this.uploadFileExtension = false;
        this.uploadedFile = null;
        this.action = "";
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.selectedFile = null;
        this.uploadFileSizeConstant = "Upload < 500MB";
        this.selectedFileName = this.uploadFileSizeConstant;
        this.fileName = "";
        this.fileList = [];
        this.selectedSiteIdSearch = 0;
        this.selectedErgIdSearch = 0;
        this.page = 0;
        this.isFileUploded = false;
        this.galleryItemsList = null;
        this.selectAllConstant = 'Select All';
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.uploadFlag = "gallery";
        this.errorMsgUploadSave = false;
        this.leadAdminId = localStorage.getItem('leadAdminId');
        this.allowedExtensions = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
        this.typeList = [{ type: this.selectAllConstant }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
        this.filterType = "document";
        this.firstEdit = false;
        this.managerFolderSiteId = localStorage.getItem('siteId');
        this.managerFolderBpgId = localStorage.getItem('bpgId');
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
    }
    DocumentRepositoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.editandSavebtn = false;
        this.savebtn = true;
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        if (localStorage.getItem('logOutFlag') === "true") {
            this.router.navigate(['/log-out']);
        }
        localStorage.removeItem('searchedEventsCaledarItems');
        this.spinner.show();
        this.logUserAction();
        if (localStorage.getItem('isbpgAdmin') === 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        sessionStorage.removeItem("MembershipData");
        if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
            localStorage.setItem('adminId', '2');
        }
        this.userAndRoleIdDTO = {
            userId: this.loginDataDetails['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.bpgCommonService.getSessionToken();
        if (this.loginUserAdminId === "3" || this.loginUserAdminId === "2" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
                _this.chapterList = data;
                if (_this.chapterList.length > 1) {
                    _this.chapterList.unshift({ chapterId: 0, siteName: _this.selectAllConstant, bpgName: '' });
                }
                for (var i = 0; i < _this.chapterList.length; i++) {
                    if (i === 0) {
                        _this.chapterIds = _this.chapterList[i].chapterId;
                    }
                    else {
                        _this.chapterIds = _this.chapterIds + "," + _this.chapterList[i].chapterId;
                    }
                }
                _this.siteData = {
                    "filter": {
                        chapterId: _this.chapterIds
                    },
                    "moduleId": 0,
                    "page": 0,
                    "presentRole": "",
                    "searchTerm": "",
                    "size": 0,
                    "sortDirection": "ASC",
                    "sortProperty": "",
                    "uid": ""
                };
                _this.bpgCommonService.getSiteList(_this.siteData).subscribe(function (data) {
                    _this.siteList = data;
                    _this.siteListSearch = data;
                    //filter default site from sitelist
                    _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch.unshift({ siteId: 0, siteName: _this.selectAllConstant, bpgName: '' });
                    for (var i = 0; i < _this.siteList.length; i++) {
                        if (i === 0) {
                            _this.allSiteIds = _this.siteList[i].siteId;
                        }
                        else {
                            _this.allSiteIds = "" + _this.allSiteIds + _this.siteList[i].siteId + ",";
                        }
                    }
                    for (var i = 0; i < _this.siteListSearch.length; i++) {
                        if (i === 0) {
                            _this.allSiteIds = _this.siteListSearch[i].siteId;
                        }
                        else {
                            _this.allSiteIds = "" + _this.allSiteIds + _this.siteListSearch[i].siteId + ",";
                        }
                    }
                    _this.getBpgList();
                    _this.getBpgListSearch();
                });
            });
            this.getSiteName();
        }
        else if (this.loginUserAdminId === "1") {
            this.getSiteName();
            this.getSiteList();
            this.getBpgList();
            this.getBpgListSearch();
            this.getChapterGalleryList();
        }
        this.loginUserId = this.loginData.userId;
        setTimeout(function () {
            this.spinner.hide();
        }.bind(this), 500);
    };
    /** get site name in the dropdown for lead admin
      * @class ConfigureGalleryComponent
      * @method getSiteName
      */
    DocumentRepositoryComponent.prototype.getSiteName = function () {
        if (this.managerFolderBpgId === undefined && this.managerFolderSiteId === undefined) {
            this.selectedSite = this.loginData.site.siteName;
        }
        else {
            this.selectedSite = localStorage.getItem('siteName');
        }
    };
    /** get site list in the dropdown
      * @class ConfigureGalleryComponent
      * @method getSiteList
      */
    DocumentRepositoryComponent.prototype.getSiteList = function () {
        var _this = this;
        this.siteData = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe(function (data) {
            _this.siteList = data;
            _this.siteListSearch = data;
            //filter default site from sitelist
            _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch.unshift({ siteId: 0, siteName: _this.selectAllConstant, bpgName: '' });
            if (_this.siteList != null || _this.siteListSearch != null) {
                if (_this.managerFolderBpgId !== undefined && _this.managerFolderSiteId !== undefined) {
                    _this.selectedSiteId = _this.managerFolderSiteId;
                }
                for (var _i = 0, _a = _this.siteList; _i < _a.length; _i++) {
                    var site = _a[_i];
                    if (site.siteId === _this.selectedSiteId) {
                        _this.selectedSite = site.siteName;
                    }
                }
                for (var _b = 0, _c = _this.siteListSearch; _b < _c.length; _b++) {
                    var siteSearch = _c[_b];
                    if (siteSearch.siteId === _this.selectedSiteId) {
                        _this.selectedSite = siteSearch.siteName;
                    }
                }
                for (var i = 0; i < _this.siteList.length; i++) {
                    if (i === 0) {
                        _this.allSiteIds = _this.siteList[i].siteId;
                    }
                    else {
                        _this.allSiteIds = "" + _this.allSiteIds + _this.siteList[i].siteId + ",";
                    }
                }
                for (var i = 0; i < _this.siteListSearch.length; i++) {
                    if (i === 0) {
                        _this.allSiteIds = _this.siteListSearch[i].siteId;
                    }
                    else {
                        _this.allSiteIds = "" + _this.allSiteIds + _this.siteListSearch[i].siteId + ",";
                    }
                }
            }
        });
    };
    /** get gallery list
     * @class ConfigureGalleryComponent
     * @method getChapterGalleryList
     */
    DocumentRepositoryComponent.prototype.getChapterGalleryList = function () {
        var _this = this;
        this.spinner.show();
        if (this.selectedSiteIdSearch === 0) {
            this.selectedSiteIdSearch = this.allSiteIds;
        }
        if (this.selectedErgIdSearch === 0) {
            this.selectedErgIdSearch = this.allBpgIds;
        }
        this.landingData = {
            "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch, "type": this.filterType, "folderId": this.selectedFolderForSearch },
            "moduleId": 0,
            "page": this.page,
            "presentRole": "string",
            "searchTerm": "string",
            "size": this.limit,
            "sortDirection": "DESC",
            "sortProperty": "created_date_time",
            "uid": "string"
        };
        this.userService.getChapterGalleryList(this.landingData).subscribe(function (data) {
            _this.galleryItemsList = data.content;
            _this.numberOfElements = data.totalElements;
            _this.spinner.hide();
            if (_this.galleryItemsList.length === 0) {
                _this.noDataFound = true;
                _this.tableShow = false;
            }
            else {
                _this.noDataFound = false;
                _this.tableShow = true;
            }
        });
    };
    /** get bpg list in the dropdown
      * @class ConfigureGalleryComponent
      * @method getBpgList
      */
    DocumentRepositoryComponent.prototype.getBpgList = function () {
        var _this = this;
        if (this.managerFolderBpgId !== 'undefined' && this.managerFolderSiteId !== 'undefined') {
            this.selectedErgId = this.managerFolderBpgId;
            this.selectedSiteId = this.managerFolderSiteId;
            this.getDocumentsFolderList();
        }
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgList = data;
            if (_this.bpgList.length === 0) {
                _this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
            }
            if (_this.bpgList != null) {
                for (var _i = 0, _a = _this.bpgList; _i < _a.length; _i++) {
                    var bpg = _a[_i];
                    if (bpg.bpgId === _this.selectedErgId) {
                        _this.selectedBpg = bpg.bpgName;
                    }
                }
                for (var i = 0; i < _this.bpgList.length; i++) {
                    if (i === 0) {
                        _this.allBpgIds = _this.bpgList[i].bpgId;
                    }
                    else {
                        _this.allBpgIds = "" + _this.allBpgIds + _this.bpgList[i].bpgId + ",";
                    }
                }
            }
        });
    };
    DocumentRepositoryComponent.prototype.getBpgListSearch = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteIdSearch,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "",
                "searchTerm": "",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "",
                "uid": ""
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgListSearch = data;
            if (_this.bpgListSearch != null) {
                _this.bpgListSearch.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
                for (var _i = 0, _a = _this.bpgListSearch; _i < _a.length; _i++) {
                    var list = _a[_i];
                    if (list.bpgId === _this.selectedErgId) {
                        _this.selectedBpg = list.bpgName;
                    }
                }
                for (var i = 0; i < _this.bpgListSearch.length; i++) {
                    if (i === 0) {
                        _this.allBpgIds = _this.bpgListSearch[i].bpgId;
                    }
                    else {
                        _this.allBpgIds = "" + _this.allBpgIds + _this.bpgListSearch[i].bpgId + ",";
                    }
                }
                if (_this.loginUserAdminId === "2" || _this.loginUserAdminId === "3" || _this.isbpgAdmin || _this.isbpgLeadAdmin) {
                    _this.getChapterGalleryList();
                }
            }
        });
    };
    /** get chapter id
    * @class ConfigureGalleryComponent
    * @method getChapterIds
    */
    DocumentRepositoryComponent.prototype.getChapterIds = function () {
        var _this = this;
        this.landingData = {
            "filter": {
                "bpgId": this.selectedErgId,
                "siteId": this.selectedSiteId
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.userService.getChapterByBpg(this.landingData).subscribe(function (data) {
            if (data != null) {
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var d = data_1[_i];
                    _this.chapterId = d;
                }
            }
        });
    };
    /** For site change from site list
       * @class ConfigureGalleryComponent
       * @method siteChange
       * @returns Promise
       */
    DocumentRepositoryComponent.prototype.siteChange = function (event) {
        this.selectedErgId = null;
        this.selectedBpg = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedSiteId = event.siteId;
        this.bpgList = [];
        this.getBpgList();
        this.eventId = null;
        this.folderId = null;
        this.folderName = null;
        this.selectedFolder = null;
        this.getDocumentsFolderList();
    };
    /** For bpg change from bpg list
      * @class ConfigureGalleryComponent
      * @method bpgChange
      * @returns Promise
      */
    DocumentRepositoryComponent.prototype.bpgChange = function (event) {
        this.selectedErgId = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedErgId = event.bpgId;
        this.getChapterIds();
        this.getDocumentsFolderList();
        this.folderId = null;
        this.folderName = null;
        this.selectedFolder = null;
    };
    DocumentRepositoryComponent.prototype.onFileSelected = function (event) {
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        if (event.target.files.length > 0) {
            this.fileName = event.target.files[0].name;
            this.fileSize = event.target.files[0].size;
            var allowedExtensions = ["mp3", "xls", "xlsx", "csv", "doc", "docx", "txt", "pdf", "ppt", "pptx", "jpg", "jpeg", "png"];
            this.fileExtension = this.fileName.split('.').pop();
            if (this.isInArray(allowedExtensions, this.fileExtension)) {
                if (this.fileSize > 524288000) {
                    this.fileSizeExtensionError = true;
                }
                else {
                    this.fileExtensionError = false;
                    this.fileSizeExtensionError = false;
                    this.selectedFile = event.target.files[0];
                    this.selectedFileName = this.selectedFile.name;
                    this.isFileUploded = true;
                }
            }
            else {
                this.fileExtensionError = true;
                this.selectedFileName = this.uploadFileSizeConstant;
            }
        }
    };
    /** checks if word exists in array
     * @class ConfigureGalleryComponent
     * @method isInArray
     */
    DocumentRepositoryComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    /** For adding 365 days to current day
  * @class ConfigureGalleryComponent
  * @method addDays
  * @params Date, number
  */
    DocumentRepositoryComponent.prototype.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    /** to submit resource
     * @class ConfigureGalleryComponent
     * @method onChapterGallerySubmit
     */
    DocumentRepositoryComponent.prototype.onDocumentRepositorySubmit = function () {
        this.alertSuccess = false;
        this.alertFailure = false;
        this.timeOutError = false;
        this.alertUpdateSuccess = false;
        this.method = "addGallery";
        this.param = '';
        if (this.editandSavebtn) {
            this.msg1 = " Are you sure you want to update ? ";
        }
        else {
            this.msg1 = " Are you sure you want to save ? ";
        }
    };
    /** to add new admin
      * @class ConfigureGalleryComponent
      * @method addGallery
      */
    DocumentRepositoryComponent.prototype.addGallery = function () {
        var _this = this;
        //removing special characters from filename
        var str = this.selectedFileName;
        var arr = str.split(".");
        var lastVal = arr.pop();
        var firstVal = arr.join(".");
        this.selectedFileName = firstVal.replace(/[&/\\#,+()$~%.'"_:*?<>{}]/g, '') + "." + lastVal;
        this.timeOutError = false;
        var galleryData = null;
        this.modifiedDateTime = new Date();
        if (this.editandSavebtn !== true) {
            galleryData = {
                "createdBy": this.createdBy,
                "createdDateTime": this.createdDateTime,
                "isActive": true,
                "modifiedBy": this.modifiedBy,
                "modifiedDateTime": this.modifiedDateTime,
                "fileName": this.selectedFileName,
                "bpgId": this.selectedErgId,
                "isEvent": null,
                "siteId": this.selectedSiteId,
                "eventId": null,
                "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
                "documentName": this.documentName,
                "folderId": this.selectedFolder
            };
        }
        else {
            galleryData = {
                "galleryId": this.galleryId,
                "createdBy": this.createdBy,
                "createdDateTime": this.createdDateTime,
                "isActive": true,
                "modifiedBy": this.modifiedBy,
                "modifiedDateTime": this.modifiedDateTime,
                "fileName": this.selectedFileName,
                "bpgId": this.selectedErgId,
                "isEvent": null,
                "siteId": this.selectedSiteId,
                "eventId": null,
                "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
                "documentName": this.documentName,
                "folderId": this.selectedFolder
            };
        }
        var uploadData = {
            'category': 'uploadDocument',
        };
        //if save condition
        this.action = "CHAPTER_GALLERY";
        this.spinner.show();
        this.userService.addGallery(galleryData).subscribe(function (data) {
            _this.galleryList = data;
            if (_this.editandSavebtn === true) {
                _this.spinner.hide();
                _this.alertUpdateSuccess = true;
                _this.deleteSuccess = false;
                _this.errorMsgUploadSave = false;
                _this.alertSuccess = false;
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 300);
                setTimeout(function () {
                    _this.resetGallery();
                }, 1500);
                _this.getChapterGalleryList();
            }
            if (data.message !== undefined) {
                _this.spinner.hide();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 300);
            }
            else if (data !== undefined) {
                _this.spinner.show();
                if (_this.selectedFile != null) {
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.galleryList.fileName, this.uploadFlag)];
                                case 1:
                                    _a.sent();
                                    if (localStorage.getItem('uploadError') === 'Error') {
                                        this.userService.deleteGallery(this.galleryList.galleryId).subscribe(function (_data) {
                                            _this.spinner.hide();
                                            _this.errorMsgUploadSave = true;
                                            _this.alertSuccess = false;
                                            _this.deleteSuccess = false;
                                            localStorage.removeItem('uploadError');
                                        });
                                    }
                                    else {
                                        if (this.editandSavebtn !== true) {
                                            this.alertSuccess = true;
                                            setTimeout(function () {
                                                _this.resetGallery();
                                            }, 1500);
                                        }
                                        this.deleteSuccess = false;
                                        this.errorMsgUploadSave = false;
                                        this.getChapterGalleryList();
                                    }
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinner.hide();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) {
                        _this.spinner.hide();
                        if (err.value.statusText === ConstantValues.unknownError) {
                            _this.timeOutError = true;
                        }
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    });
                }
            }
        });
    };
    /** For filtering data by current page
     * @class ConfigureGalleryComponent
     * @method pageChanged
     * @params event
     */
    DocumentRepositoryComponent.prototype.pageChanged = function (event) {
        this.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getChapterGalleryList();
    };
    /** Confirm on reset
      * @class ConfigureGalleryComponent
      * @method resetGallery
      */
    DocumentRepositoryComponent.prototype.resetGallery = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.myInputVariable.nativeElement.value = "";
        this.selectedBpg = null;
        this.selectedErgId = null;
        this.folderId = null;
        this.folderName = null;
        this.selectedFolder = null;
        this.selectedErgIdSearch = null;
        this.selectedSiteIdSearch = null;
        this.searchKey = null;
        this.LandingPaginationDTO.searchTerm = null;
        this.selectedFileName = this.uploadFileSizeConstant;
        this.selectedSiteId = localStorage.getItem('userSiteId');
        this.eventId = null;
        this.deleteSuccess = false;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.alertSuccess = false;
        this.selectedFile = null;
        this.isFileUploded = false;
        this.selectedBpgSearch = null;
        this.selectedSiteSearch = null;
        this.errorMsgUploadSave = false;
        this.documentName = "";
        this.selectedSite = this.loginData.site.siteName;
        this.eventPicture = true;
        this.editandSavebtn = false;
        this.savebtn = true;
        this.firstEdit = false;
        this.selectedFolderForSearch = null;
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.selectedSiteIdSearch = 0;
            this.selectedErgIdSearch = 0;
            this.getBpgListSearch();
        }
        this.getChapterGalleryList();
        this.getBpgList();
    };
    /** For site change from site list
     * @class ConfigureGalleryComponent
     * @method siteChangeSearch
     * @returns Promise
     */
    DocumentRepositoryComponent.prototype.siteChangeSearch = function (event) {
        this.selectedSiteIdSearch = event.siteId;
        this.getBpgListSearch();
        this.folderId = null;
        this.folderName = null;
        this.selectedFolderForSearch = null;
        this.getDocumentsFolderListSearch();
    };
    /** For bpg change from bpg list
      * @class ConfigureGalleryComponent
      * @method bpgChangeSearch
      * @returns Promise
      */
    DocumentRepositoryComponent.prototype.bpgChangeSearch = function (event) {
        this.selectedErgId = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedErgIdSearch = event.bpgId;
        this.selectedErgId = event.bpgId;
        this.getChapterIds();
        this.getDocumentsFolderListSearch();
        this.folderId = null;
        this.folderName = null;
        this.selectedFolderForSearch = null;
    };
    /** confirmation to delete gallery
  * @class ConfigureGalleryComponent
  * @method deleteGalleryConfirmation
  */
    DocumentRepositoryComponent.prototype.deleteGalleryConfirmation = function (id) {
        this.alertSuccess = false;
        this.alertFailure = false;
        this.timeOutError = false;
        this.alertUpdateSuccess = false;
        this.method = "deleteGallery";
        this.param = id;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    /** to Delete gallery
  * @class ConfigureGalleryComponent
  * @method deleteGallery
  */
    DocumentRepositoryComponent.prototype.deleteGallery = function (galleryId) {
        var _this = this;
        this.spinner.show();
        this.userService.deleteGallery(galleryId).subscribe(function (_data) {
            _this.spinner.hide();
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            _this.deleteSuccess = true;
            _this.alertSuccess = false;
            _this.errorMsgUploadSave = false;
            if (_this.galleryItemsList.length === 1 && _this.numberOfElements > 10) {
                _this.currentPage = 0;
                _this.page = 0;
                _this.currentShowingElements = 10;
            }
            _this.getChapterGalleryList();
        });
    };
    DocumentRepositoryComponent.prototype.downloadDocument = function (urls, i) {
        var extension = urls.substring(urls.lastIndexOf('.') + 1);
        var link = document.getElementById('downloadFiles' + i);
        link.setAttribute('href', urls);
        link.setAttribute('download', urls);
        if (extension.includes('mp4')) {
            link.setAttribute('target', '_blank');
        }
    };
    /** to reset resource
     * @class ConfigureGalleryComponent
     * @method resetClick
     */
    DocumentRepositoryComponent.prototype.resetClick = function () {
        this.method = "resetGallery";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    DocumentRepositoryComponent.prototype.getChapterGalleryListSearch = function () {
        this.page = 0;
        this.currentPage = 1;
        this.getChapterGalleryList();
    };
    /** get gallery list
   * @class ConfigureGalleryComponent
   * @method getChapterGalleryList
   */
    DocumentRepositoryComponent.prototype.getDocumentsFolderList = function () {
        var _this = this;
        this.spinner.show();
        if (this.selectedSiteId === 0) {
            this.selectedSiteId = this.allSiteIds;
        }
        if (this.selectedErgId === 0) {
            this.selectedErgId = this.allBpgIds;
        }
        if (this.managerFolderBpgId !== 'undefined' && this.managerFolderSiteId !== 'undefined') {
            this.selectedBpg = this.managerFolderBpgId;
            this.selectedSiteId = this.managerFolderSiteId;
        }
        this.landingData = {
            "filter": { "siteId": this.selectedSiteId, "bpgId": this.selectedErgId },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 1000,
            "sortDirection": "ASC",
            "sortProperty": "folder_name",
            "uid": ""
        };
        this.userService.getDocumentsFolderList(this.landingData).subscribe(function (data) {
            _this.folderList = data.content;
            _this.spinner.hide();
        });
    };
    /** get gallery list
  * @class ConfigureGalleryComponent
  * @method getChapterGalleryList
  */
    DocumentRepositoryComponent.prototype.getDocumentsFolderListSearch = function () {
        var _this = this;
        this.spinner.show();
        if (this.selectedSiteIdSearch === 0) {
            this.selectedSiteIdSearch = this.allSiteIds;
        }
        if (this.selectedErgIdSearch === 0) {
            this.selectedErgIdSearch = this.allBpgIds;
        }
        this.landingData = {
            "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 1000,
            "sortDirection": "ASC",
            "sortProperty": "folder_name",
            "uid": ""
        };
        this.userService.getDocumentsFolderList(this.landingData).subscribe(function (data) {
            _this.folderListForSearch = data.content;
            _this.spinner.hide();
        });
    };
    /** to add new admin
     * @class ConfigureGalleryComponent
     * @method addGallery
     */
    DocumentRepositoryComponent.prototype.updateGallery = function (data) {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertSuccess = false;
        this.alertFailure = false;
        this.editandSavebtn = true;
        this.savebtn = false;
        this.timeOutError = false;
        this.modifiedDateTime = new Date();
        this.modifiedBy = this.loginDataDetails['userId'];
        this.createdBy = this.loginDataDetails['userId'];
        this.createdDateTime = new Date();
        this.selectedFileName = data.originalFileName;
        this.selectedFolder = data.folderId;
        this.folderName = data.folderName;
        this.folderId = data.folderId;
        this.documentName = data.documentName;
        this.selectedBpg = data.bpgName;
        this.selectedErgId = data.bpgId;
        this.selectedSite = data.siteName;
        this.selectedSiteId = data.siteId;
        this.galleryId = data.galleryId;
        this.getDocumentsFolderList();
    };
    DocumentRepositoryComponent.prototype.editDocument = function (data, i) {
        if (this.firstEdit === false) {
            this.firstEdit = true;
            this.updateGallery(data);
        }
        else {
            document.getElementById('edit' + i).setAttribute('data-toggle', 'modal');
            document.getElementById('edit' + i).setAttribute('data-target', '#myModal');
            this.method = "updateGallery";
            this.param = data;
            this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
        }
    };
    DocumentRepositoryComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Chapter Resources Screen"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return DocumentRepositoryComponent;
}());
export { DocumentRepositoryComponent };
